if (!customElements.get('klaviyo-bis')) {
  class KlaviyoBis extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      if (!this.form || !this.submitButton) return;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.url = {
        id: 'https://a.klaviyo.com/client/subscriptions',
        email: 'https://a.klaviyo.com/client/back-in-stock-subscriptions'
      };
      this.errorPlace = this.querySelector('[data-error-message]');
    }

    getProductVarianId() {
      const sectionSelect = this.closest('.shopify-section').querySelector('.product-purchase-form select[name="id"]');
      if (sectionSelect) return sectionSelect.value;
      const { variantId, variantIdSelector, variantIdSelectorDataset } = this.dataset;
      if (variantId) return variantId;

      if (!variantIdSelector || !variantIdSelectorDataset) return '';

      const parent = this.closest(variantIdSelector);
      return parent ? parent.dataset[variantIdSelectorDataset] : '';
    }

    onSubmitHandler(event) {
      event.preventDefault();
      if (!this.form || !this.dataset.api || !this.dataset.revision) return;

      const formData = new FormData(this.form);
      const email = formData.get('email');
      const revision = this.dataset.revision;

      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const requestParameters = new URLSearchParams({
        company_id: this.dataset.api
      });

      this.options = [...formData.entries()].reduce((p, [key, value]) => ({
        ...p,
        [`${key}`]: {
          method: 'POST',
          headers: {
            revision: revision,
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              type: { id: 'subscription', email: 'back-in-stock-subscription' }[key],
              attributes: {
                ...({
                  id: { custom_source: 'backinstock_pop_up' },
                  email: { channels: ['EMAIL'] }
                }[key]),
                profile: { data: { type: 'profile', attributes: { email } } }
              },
              relationships: {
                ...({
                  id: { list: { data: { type: 'list', id: value } } },
                  email: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.getProductVarianId()}` } } }
                }[key])
              }
            }
          })
        }
      }), {});

      (async () => {
        await Object.entries(this.options).reduce(async (p, [key, option]) => {
          await p;
          const response = await fetch(`${this.url[key]}?${requestParameters}`, option);
          if (response.ok) {
            this.querySelector(".form__message--success").classList.remove('hidden');
          } else {
            const { errors } = await response.json();
            const error = errors?.map(({ title }) => title).join('\n') || 'HTTP error';
            this.querySelector('.error-message')?.insertAdjacentText('beforeend', error);
            this.querySelector(".form__message--error").classList.remove('hidden');
          }
        }, Promise.resolve());

        this.submitButton.setAttribute('aria-disabled', 'false');
        this.submitButton.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        setTimeout(() => {
          this.querySelector(".form__message--success").classList.add('hidden');
          this.querySelector(".form__message--error").classList.add('hidden');
        }, 3000);
        this.form.reset();
      })();
    }
  }

  customElements.define('klaviyo-bis', KlaviyoBis);
}